import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=9f45db10&scoped=true&"
import script from "./Contests.vue?vue&type=script&lang=js&"
export * from "./Contests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45db10",
  null
  
)

export default component.exports